import { getJsonRequest, postJsonRequest } from '@chilecompra/react-kit'
import { REACT_APP_API_BASE_URL } from '../config/settings/environment'
import factoryAuthService from '../modules/requests/services'

/**
 * Get contingency options.
 */
export const getContingencyOptions = factoryAuthService(() =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/contingentTheme/configurationinicial`)
)

/**
 * Get contingencies traded amounts.
 */
export const getContingencyExpense = factoryAuthService(({ contingencyId, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/contingentTheme/montokpi/${contingencyId}/${year}`)
)

/**
 * Get contingencies traded amounts.
 */
export const getTradedAmounts = factoryAuthService(({ contingencyId, years }) => {
  const body = {
    idTemaContingente: contingencyId,
    years
  }
  return postJsonRequest(`${REACT_APP_API_BASE_URL}/v1/contingentTheme/accumulatedAmount`, { body })
})

/**
 * Get purchasing Mechanisms for year
 */
export const getPurchasingMechanisms = factoryAuthService(({ contingencyId, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/contingentTheme/purchase/${contingencyId}/${year}`)
)

/**
 * Gets the segments by the given identifier, and year.
 */
export const getSegments = factoryAuthService(({ contingencyId, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/contingentTheme/getSectors/${contingencyId}/${year}`)
)

/**
 * Gets the families by the given identifiers, and year.
 */
export const getFamilies = factoryAuthService(({ contingencyId, year, segmentId }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/contingentTheme/getBySegment/${contingencyId}/${year}/${segmentId}`)
)

/**
 * Gets the categories by the given identifiers, and year
 */
export const getCategories = factoryAuthService(({ contingencyId, familyId, segmentId, year }) =>
  getJsonRequest(
    `${REACT_APP_API_BASE_URL}/v1/contingentTheme/getByFamily/${contingencyId}/${year}/${segmentId}/${familyId}`
  )
)

/**
 * Gets the products by the given identifier, category, family, segment, and year.
 */
export const getProducts = factoryAuthService(({ categoryId, contingencyId, familyId, segmentId, year }) =>
  getJsonRequest(
    `${REACT_APP_API_BASE_URL}/v1/contingentTheme/getByCategory/${contingencyId}/${year}/${segmentId}/${familyId}/${categoryId}`
  )
)

/**
 * Get the entire Provider's list
 */
export const getContingenciesBuyerList = factoryAuthService(({ contingencyId, direction, order, page, year }) =>
  getJsonRequest(
    `${REACT_APP_API_BASE_URL}/v1/contingentTheme/find/list?year=${year}&idTemaContingente=${contingencyId}&page=${page}&size=10&order=${order}&direction=${direction}`
  )
)

/**
 * Get purchases for sector for year
 */
export const getPurchasesSector = factoryAuthService(({ year, contingencyId }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/contingentTheme/sector/${contingencyId}/${year}`)
)
